import React, { useEffect, useContext } from "react";
import { RightsContext } from "providers/RightsContext";
import { hasAuthorization } from "utils/functions";
import * as rightsCodes from "constants/rightsCodes";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import HeaderPortal from "components/layout/HeaderPortal";
import ClientOfferChart from "./averageCharts/ClientOfferChart";
import ClientOfferStatusChart from "./averageCharts/ClientOfferStatusChart";
import ClientStatusChart from "./averageCharts/ClientStatusChart";
import {
  loadClientOfferChartData,
  loadTopClientsChartData,
  loadLatestClientsChartData,
  loadClientOfferStatusChartData
} from "../actionCreators";
import { useTranslation } from "react-i18next";
import { StretchedCardContainer } from "./DashboardStyles";

const Dashboard = ({
  actions,
  clientOfferChartData,
  clientOfferStatusChartData,
  topClientsChartData,
  latestClientsChartData
}) => {
  const { t } = useTranslation();
  const rights = useContext(RightsContext);
  const hasDashboardPermission = hasAuthorization(rightsCodes.MASTER_PARTNER_DASHBOARD, rights);

  useEffect(() => {
    loadClientOfferChartData(false);
    loadClientOfferStatusChartData(false);
    loadTopClientsChartData(false);
    loadLatestClientsChartData(false);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const loadClientOfferChartData = (force = true) => {
    actions.loadClientOfferChartData(force);
  };

  const loadClientOfferStatusChartData = (force = true) => {
    actions.loadClientOfferStatusChartData(force);
  };

  const loadTopClientsChartData = (force = true) => {
    actions.loadTopClientsChartData(force);
  };

  const loadLatestClientsChartData = (force = true) => {
    actions.loadLatestClientsChartData(force);
  };

  return !hasDashboardPermission ? null : (
    <>
      <HeaderPortal />
      <Grid container spacing={2} mt={2} alignItems={"stretch"}>
        <StretchedCardContainer item xs={12} lg={6}>
          {clientOfferChartData && (
            <ClientOfferChart
              clientOfferChartData={clientOfferChartData}
              loadClientOfferChartData={loadClientOfferChartData}
            />
          )}
        </StretchedCardContainer>
        <StretchedCardContainer item xs={12} lg={6}>
          {topClientsChartData && (
            <ClientStatusChart
              chartData={topClientsChartData}
              loadChartData={loadTopClientsChartData}
              title={t("Dashboard.TopClients")}
            />
          )}
        </StretchedCardContainer>
        <StretchedCardContainer item xs={12} lg={6}>
          {clientOfferStatusChartData && (
            <ClientOfferStatusChart
              clientOfferChartData={clientOfferStatusChartData}
              loadClientOfferChartData={loadClientOfferStatusChartData}
            />
          )}
        </StretchedCardContainer>
        <StretchedCardContainer item xs={12} lg={6}>
          {latestClientsChartData && (
            <ClientStatusChart
              chartData={latestClientsChartData}
              loadChartData={loadLatestClientsChartData}
              title={t("Dashboard.LatestClients")}
            />
          )}
        </StretchedCardContainer>
      </Grid>
    </>
  );
};

Dashboard.propTypes = {
  actions: PropTypes.object.isRequired,
  clientOfferChartData: PropTypes.object,
  clientOfferStatusChartData: PropTypes.object,
  topClientsChartData: PropTypes.object,
  latestClientsChartData: PropTypes.object
};

function mapStateToProps(state) {
  return {
    clientOfferChartData: state.dashboard.clientOfferChartData,
    clientOfferStatusChartData: state.dashboard.clientOfferStatusChartData,
    topClientsChartData: state.dashboard.topClientsChartData,
    latestClientsChartData: state.dashboard.latestClientsChartData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadClientOfferChartData,
        loadClientOfferStatusChartData,
        loadTopClientsChartData,
        loadLatestClientsChartData
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
